import 'slick-carousel';

// NEW JS FOR TOOGLE FILTERS //

jQuery('.open-close .checkboxes-wrapper .show-more').each(function () {
	jQuery(this).text(jQuery(this).attr('data-more-button-label'));
});

if (jQuery('.open-close label').length > 3) {
	jQuery(".checkboxes-wrapper").each(function () {
		jQuery(this).find(":nth-child(n+4)").hide();
		jQuery(this).find(".show-more").show();
		jQuery(this).find(".show-more").on("click", function () {
			jQuery(this).parent().find('div.checkbox:nth-child(n+4)').show();
			jQuery(this).parent().find('.show-more').hide();
		});
	});
}

jQuery(".show-more-button.open-filters").on("click", function () {
	jQuery('.clearfix.bordered-box.show-mobile-search-filters.content-fields.extra-padding').show();
	$('.search-list-bottom').addClass('hidden');
});

jQuery(".filter-header .filters-close").on("click", function () {
	jQuery('.clearfix.bordered-box.show-mobile-search-filters.content-fields.extra-padding').hide();
	$('.search-list-bottom').removeClass('hidden');
});
jQuery("#detailed-search-form").on("submit", function() {
	if (window.matchMedia('(max-width: 991px)').matches) {
		jQuery('.clearfix.bordered-box.show-mobile-search-filters.content-fields.extra-padding').hide();
		$('.search-list-bottom').removeClass('hidden');
	}
})
jQuery(".clear-filters").on('click', function() {
	jQuery('.show-mobile-search-filters .checkbox').each(function() {
		jQuery(this).find("input").attr("checked", false);
	})
})
jQuery('.house-header-map-wrapper .mobile-info-text').slick({
	arrows: false,
	dots: true,
	autoplay: true,
	autoplaySpeed: 5000
});

if (window.matchMedia('(max-width: 991px)').matches) {
	jQuery(document).ready(function () {

		

		// jQuery(".search-page-content").each(function () {
		// 	jQuery(this).find(".house-header-map-wrapper").insertAfter(jQuery(this).find(".mobileLast"));
		//
		// });

		jQuery('.modal .info-boxes-wrap, .modal-static .info-boxes-wrap').slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: true,
			arrows: false,
			autoplaySpeed: 5000
		});

		jQuery( '.header-sgr, .header-tourvers, .home-bottom-info__item_sgrtourvers' ).on( 'click' , function(){
			setTimeout(function () {
				jQuery('.modal .info-boxes-wrap').slick("refresh");
			}, 50);
		} );

		var path = window.location.pathname;
		if (path != '/' && path != '/app_dev.php/') {
			var url = jQuery('#sgrModal').data('sgrtourvers-url');
			jQuery('#sgrModal').attr('id', 'sgrModal-d');
			jQuery('.home-bottom-info__item_sgrtourvers').removeAttr('data-toggle').removeAttr('data-target').attr('href', url);
			jQuery('.header-sgr, .header-tourvers').parent().removeAttr('data-toggle').removeAttr('data-target').attr('href', url);
			jQuery('a[data-target="#sgrModal"]').removeAttr('data-toggle').removeAttr('data-target').attr('href', url);
		}
	})
}

jQuery(document).ready(function () {
	if (jQuery('#sgrModal').length > 0) {
		jQuery('.header-sgr, .header-tourvers').parent().attr('data-toggle', 'modal');
		jQuery('.header-sgr, .header-tourvers').parent().attr('data-target', '#sgrModal');
		jQuery('.header-sgr, .header-tourvers').parent().attr('href', '#');
	}
});
